module.exports = __webpack_public_path__ + "static/media/arrowDown.c6142cd3.png";